import { faMapPin } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Box, makeStyles, useTheme } from '@material-ui/core';
import { Room } from '@material-ui/icons';
import clsx from 'clsx';
import { get } from "lodash";
import React, { useMemo } from 'react';
import { ETA } from './ETA';
import './pulse.scss';

const useStyles = makeStyles((theme) => {
  return {
    pinRoot: {
      position: 'relative',
      backgroundColor:"#FF00FF",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      width: 2,
      height: 2,
      zIndex: 1
    },
    pinBase: {
      display: "inline-flex",
      height: theme.spacing(6),
      width: theme.spacing(6),
      top: 0,
      boxShadow: theme.shadows[3],
    },
    noPulsePinBase: {
      display: "inline-flex",
      height: theme.spacing(6),
      width: theme.spacing(6),

    },
    pulse: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translateX(-50%) translateY(-50%)",
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
    noPulse: {
      transform: "translateX(-12px) translateY(-50%)",
    },
    homePin:{
      transform: "translateX(-50%) translateY(-100%)",
      
    },
    userMarker:{
      transform: "translateX(-50%) translateY(-50%)",
      position: "absolute",
      left: "50%",
      top: "50%",
      borderRadius: "50%",
      border: "2px solid #FFF",
      boxShadow: theme.shadows[3],
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: theme.palette.primary.light,
    }
  }
})

const PROVIDER_ICON_MAPPING = {
  MASSAGE_THERAPIST: {
    male: "icon_provider_wellness_available_m",
    female: "icon_provider_wellness_available",
    maleFavorite: "icon_provider_wellness_favorite_m",
    femaleFavorite: "icon_provider_wellness_favorite"
  },
  HEALTH_WORKER: {
    male: "icon_provider_health_available_m",
    female: "icon_provider_health_available",
    maleFavorite: "icon_provider_health_favorite_m",
    femaleFavorite: "icon_provider_health_favorite"
  },
  PHYSICAL_THERAPIST: {
    male: "icon_provider_health_available_m",
    female: "icon_provider_health_available",
    maleFavorite: "icon_provider_health_favorite_m",
    femaleFavorite: "icon_provider_health_favorite"
  },
  NURSE: {
    male: "icon_provider_med_available_m",
    female: "icon_provider_med_available",
    maleFavorite: "icon_provider_med_favorite_m",
    femaleFavorite: "icon_provider_med_favorite"
  },
  MED_TECH: {
    male: "icon_provider_medtech_available_m",
    female: "icon_provider_medtech_available",
    maleFavorite: "icon_provider_medtech_favorite_m",
    femaleFavorite: "icon_provider_medtech_favorite"
  },
  DOCTOR: {
    male: "icon_provider_wellness_available_m",
    female: "icon_provider_wellness_available",
    maleFavorite: "icon_provider_wellness_favorite_m",
    femaleFavorite: "icon_provider_wellness_favorite"
  },
}
const Pin = ({ item }) => {
  const classes = useStyles()
  const theme = useTheme()
  const pinComponent = useMemo(() => {
    const provIcon = get(PROVIDER_ICON_MAPPING, `${item?.provider?.type}.${item?.provider?.gender}`)
    const provSrc = `/assets/images/providerIcons/${provIcon}.svg`
    switch (item.type) {
      case 'provider':
        return (
          <div className={classes.pinRoot}>
            <div className={clsx(classes.pulse, "pulse")}></div>
            <Avatar className={clsx(classes.pinBase, classes.pulse)} alt={item?.provider?.type} src={provSrc} />
            <ETA eta={item?.eta} travelMethod={item?.travelMethod} waitingDistance={item?.distance} state={item?.state}/>
          </div>
        )
      default:
        return (
          <div className={classes.pinRoot}>
            <div className={classes.userMarker}></div>
            <FontAwesomeIcon className={classes.homePin} size="5x" 
            icon={faMapPin}
            color={theme.palette.primary.dark}/>
            
          </div>
        )
    }

  }, [classes.homePin, classes.pinBase, classes.pinRoot, classes.pulse, classes.userMarker, item?.eta, item?.provider?.gender, item?.provider?.type, item?.state, item.type, theme.palette.primary.dark]);

  return pinComponent
}

export default React.memo(Pin);